const MARKETJWTTOKEN = 'ykx-market-jwt-token'
const MARKETJWTUSER = 'ykx-market-user'
const initMarketJwtToken = localStorage[MARKETJWTTOKEN]
const initMarketUser = localStorage[MARKETJWTUSER] ? JSON.parse(localStorage[MARKETJWTUSER]) : null

const plugin = store => {
  store.subscribe((mutation, state) => {
    switch (mutation.type) {
      case 'auth/setToken':
        localStorage[MARKETJWTTOKEN] = mutation.payload
        break
      case 'auth/resetToken':
        localStorage.removeItem(MARKETJWTTOKEN)
        break
      case 'auth/setUser':
        localStorage[MARKETJWTUSER] = JSON.stringify(mutation.payload)
        break
      case 'auth/resetUser':
        localStorage.removeItem(MARKETJWTUSER)
        break
    }
  })
}

export default plugin
export { initMarketJwtToken, initMarketUser }



// WEBPACK FOOTER //
// ./src/store/plugins/localStorage.js